import { useMutation } from 'react-query';

import { uploadUserImageByUserName as mutationFn } from 'api/endPoints/uploadUserImageByUserName';

export const useMutationUploadUserImage = () => {
    return useMutation<unknown, QueryError, unknown>('updateUserImage', (params) => mutationFn(params));
};
